import React, { Component } from 'react';
import ViewPrivacyPolicyComponent from '../components/viewPrivacyPolicyComponent';
import { getPrivacyPolicyFunc } from '../action/privacyPolicyAction';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

export class ViewPrivacyPolicyContainer extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.actions.getPrivacyPolicyFunc();
    }
    getAllData = () => {
        this.props.actions.getPrivacyPolicyFunc(
            this.props.dispatch
        )
    }
    updateTermsOfUseDetails = (data) => {
        this.props.actions.updateTermsOfUse(
            data,
            this.props.dispatch
        )
    }
    updateAcceptTermsOfUseData = (data) => {
        this.props.actions.updateAcceptTermsOfUse(
            data,
            this.props.dispatch
        )
    }
    updateTermsOfUseHeaderData = (data) => {
        this.props.actions.updateTermsOfUseHeader(
            data,
            this.props.dispatch
        )
    }
    updatePrivacyPolicyFunc = (data) => {
        this.props.actions.updatePrivacyPolicy(
            data,
            this.props.dispatch
        )
    }
    render() {
        return (<div>
            <ViewPrivacyPolicyComponent
                getPrivacyPolicyDetails={this.props.privacyPolicyDetails}
                // updateTermsOfUseDetails={this.updateTermsOfUseDetails}
                // updateAcceptTermsOfUseFunc={this.updateAcceptTermsOfUseData}
                // updateTermsOfUseHeaderFunc={this.updateTermsOfUseHeaderData}
                // updatePrivacyPolicyFunc={this.updatePrivacyPolicyFunc}
                getAllTermsData={this.getAllData}
            >
            </ViewPrivacyPolicyComponent>
        </div>)

    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getPrivacyPolicyFunc
        },
            dispatch)
    };
}

function mapStateToProps({ PrivacyPolicyReducer }) {
    console.log(PrivacyPolicyReducer)
    return {
        privacyPolicyDetails: {
            errorCode: PrivacyPolicyReducer.errorCode,
            statusCode: PrivacyPolicyReducer.statusCode,
            updatedValue: PrivacyPolicyReducer.updatedValue,
            Message : PrivacyPolicyReducer.Message
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewPrivacyPolicyContainer));